import { ReactComponent as Youtube64 } from '../../images/icon-components/partners/youtube/64.svg'
import { ReactComponent as Youtube48 } from '../../images/icon-components/partners/youtube/48.svg'
import { ReactComponent as Youtube40 } from '../../images/icon-components/partners/youtube/40.svg'

import { ReactComponent as BigoAds64 } from '../../images/icon-components/partners/bigo-ads/64.svg'
import { ReactComponent as BigoAds48 } from '../../images/icon-components/partners/bigo-ads/48.svg'
import { ReactComponent as BigoAds40 } from '../../images/icon-components/partners/bigo-ads/40.svg'

import { ReactComponent as Getuniq64 } from '../../images/icon-components/partners/getuniq/64.svg'
import { ReactComponent as Getuniq48 } from '../../images/icon-components/partners/getuniq/48.svg'
import { ReactComponent as Getuniq40 } from '../../images/icon-components/partners/getuniq/40.svg'

import { ReactComponent as Googleads64 } from '../../images/icon-components/partners/googleads/64.svg'
import { ReactComponent as Googleads48 } from '../../images/icon-components/partners/googleads/48.svg'
import { ReactComponent as Googleads40 } from '../../images/icon-components/partners/googleads/40.svg'

import { ReactComponent as Telegram64 } from '../../images/icon-components/partners/telegram/64.svg'
import { ReactComponent as Telegram48 } from '../../images/icon-components/partners/telegram/48.svg'
import { ReactComponent as Telegram40 } from '../../images/icon-components/partners/telegram/40.svg'

import { ReactComponent as Tiktok64 } from '../../images/icon-components/partners/tiktok/64.svg'
import { ReactComponent as Tiktok48 } from '../../images/icon-components/partners/tiktok/48.svg'
import { ReactComponent as Tiktok40 } from '../../images/icon-components/partners/tiktok/40.svg'

import { ReactComponent as YandexDirect64 } from '../../images/icon-components/partners/yandex-direct/64.svg'
import { ReactComponent as YandexDirect48 } from '../../images/icon-components/partners/yandex-direct/48.svg'
import { ReactComponent as YandexDirect40 } from '../../images/icon-components/partners/yandex-direct/40.svg'

const config = {
  youtube: {
    l: Youtube64,
    m: Youtube48,
    s: Youtube40,
  },
  'bigo-ads': {
    l: BigoAds64,
    m: BigoAds48,
    s: BigoAds40,
  },
  getuniq: {
    l: Getuniq64,
    m: Getuniq48,
    s: Getuniq40,
  },
  'google-ads': {
    l: Googleads64,
    m: Googleads48,
    s: Googleads40,
  },
  telegram: {
    l: Telegram64,
    m: Telegram48,
    s: Telegram40,
  },
  'tik-tok': {
    l: Tiktok64,
    m: Tiktok48,
    s: Tiktok40,
  },
  'yandex-direct': {
    l: YandexDirect64,
    m: YandexDirect48,
    s: YandexDirect40,
  },
}

export default config
